import type { SchemaOf } from '../helpers';
import { Joi, objectSchemaOf } from '../helpers';

export interface ILoadRawParams {
  configId: 'DEFAULT' | string;
}

export const loadRawParamsSchemaMap: SchemaOf<ILoadRawParams> = {
  configId: Joi.string().required(),
};

export const loadRawParamsSchema = objectSchemaOf<ILoadRawParams>(
  loadRawParamsSchemaMap
);
